module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.content) ? _c('div', {
    staticClass: "team-gallery"
  }, _vm._l((_vm.content.tabcontent), function(team) {
    return _c('div', {
      staticClass: "team-gallery__content"
    }, [_c('img', {
      attrs: {
        "src": team.photo
      }
    }), _c('div', {
      staticClass: "team-gallery__name"
    }, [_vm._v(_vm._s(team.name))]), _c('div', {
      staticClass: "team-gallery__position"
    }, [_vm._v(_vm._s(team.position))])])
  }), 0) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f10e934","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-about-team/team-gallery/team-gallery.pug
// module id = 617
// module chunks = 1